/**
 * Fix-plan step predicates — the frontend half of the backend's
 * `solver/fix-plans.ts`. The problem card reads them to decide whether a step
 * still offers its buttons.
 *
 * The second reader was the incident status chip, which asked whether a
 * `waiting_on_others` incident was genuinely waiting on anyone. That question
 * went away on 2026-08-17 when the chip narrowed to outcomes and stopped
 * badging active statuses at all: `handOffPhase` was deleted, and
 * `nextUnexecutedStep` went with it — nothing else read it, and an exported
 * helper no surface calls reads as a rule that is still in force.
 *
 * The terminal set mirrors the backend's `TERMINAL_STEP_STATUSES` exactly.
 * `approved` and `issued` are deliberately NOT terminal — an approved
 * automatic step still has to execute, and an issued manual step is the whole
 * point of the waiting state.
 */

import type { FixStepStatus } from "./types";

const TERMINAL_STEP_STATUSES: readonly FixStepStatus[] = [
  "executed",
  "done",
  "skipped",
];

export function isStepComplete(status: FixStepStatus): boolean {
  return TERMINAL_STEP_STATUSES.includes(status);
}
